export default __webpack_public_path__ + "static/media/AtomsAndCompounds _17.3e89fcfc.png";